import { render, staticRenderFns } from "./devStatusBlock.vue?vue&type=template&id=b889e9aa&scoped=true&"
import script from "./devStatusBlock.vue?vue&type=script&lang=js&"
export * from "./devStatusBlock.vue?vue&type=script&lang=js&"
import style0 from "./devStatusBlock.vue?vue&type=style&index=0&id=b889e9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889e9aa",
  null
  
)

export default component.exports